import type { FC } from "react";
import { Typography } from "@mui/material";
import { DragDropCard } from "./DragDropCard";
import { DragDropCardList } from "../../utility/interfaces/carePlanInterfaces";
import { useTranslation } from "react-i18next";

interface DraggableItemProps {
  cards: DragDropCardList[];
  onMoveCard: (dragIndex: number, hoverIndex: number) => void;
}

export const DraggableItem: FC<DraggableItemProps> = ({
  cards,
  onMoveCard,
}) => {
  const { t } = useTranslation();
  return (
    <div className="card-container">
      <Typography
        variant="bodySmall"
        color="text.secondary"
        sx={{ mb: "1rem", textAlign: "left",textTransform: "uppercase", fontWeight: "700" }}
      >
        {t("most")}
      </Typography>

      {cards.map((card, index) => (
        <div
          key={card.appModuleId}
          className="full-width"
        >
          <DragDropCard
            index={index}
            id={card.appModuleId}
            text={card.appModuleDisplayName}
            moveCard={onMoveCard}
          />
        </div>
      ))}

      <Typography
        variant="bodySmall"
        color="text.secondary"
        sx={{ mb: "1rem", textAlign: "left", textTransform: "uppercase", fontWeight: "700" }}
      >
        {t("least")}
      </Typography>
    </div>
  );
};

export default DraggableItem;
